import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import PlanSelection from './pages/PlanSelection';
import Payment from './pages/Payment';
import Registration from './pages/Registration';
import Agreements from './pages/Agreements';
import ToS from './pages/ToS';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import PlanIntro from './pages/PlanIntro';
import PlanConfirmation from './pages/PlanConfirmation';
import RegistrationComplete from './pages/RegistrationComplete';
import RedirectToApp from './pages/RedirectToApp';
import RecoveryLanding from './pages/RecoveryLanding';
import Account from './pages/Account';
import CustomerService from './pages/CustomerService';
import InquiryAnswer from './pages/InquiryAnswer';
import Inquiry from './pages/Inquiry';
import InquirySuccess from './pages/InquirySuccess';
import { useTranslation } from 'react-i18next';
import { getCurrentLangugage } from './i18n';
import { useEffect } from 'react';
import ModeChange from './pages/ModeChange';
import { AppProvider } from './store/AppContext';
import PlanChange from './pages/PlanChange';
import PlanChangeConfirmation from './pages/PlanChangeConfirmation';
import PlanIntroUpdate from './pages/PlanIntroUpdate';
import PlanChangeComplete from './pages/PlanChangeComplete';
import DataDeletion from './pages/DataDeletion';
import CS from './pages/CS';

function App() {
  const { i18n } = useTranslation();
  useEffect(() => { getCurrentLangugage() }, [])
  return (
    <AppProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Registration />} />
          <Route path="/agreements" element={<Agreements />} />
          <Route path="/privacy_policy" element={<PrivacyPolicy />} />
          <Route path="/tos" element={<ToS />} />
          <Route path="/cookie_policy" element={<CookiePolicy />} />
          <Route path="/plan_intro" element={<PlanIntro />} />
          <Route path="/plan" element={<PlanSelection />} />
          <Route path="/plan_confirmation" element={<PlanConfirmation />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/registration_complete" element={<RegistrationComplete />} />
          <Route path="/redirect-to-app" element={<RedirectToApp />} />
          <Route path="/recovery_landing" element={<RecoveryLanding />} />
          <Route path="/error" element={<div>There is something wrong</div>} />
          <Route path="/account" element={<Account />} />
          <Route path="/customer_service" element={<CustomerService />} />
          <Route path="/inquiry_answer" element={<InquiryAnswer />} />
          <Route path="/inquiry" element={<Inquiry />} />
          <Route path="/inquiry_success" element={<InquirySuccess />} />
          <Route path="/mode_change" element={<ModeChange />} />
          <Route path="/plan_change" element={<PlanChange />} />
          <Route path="/plan_change_confirmation" element={<PlanChangeConfirmation />} />
          <Route path="/plan_intro_update" element={<PlanIntroUpdate />} />
          <Route path="/plan_change_complete" element={<PlanChangeComplete/>} />
          <Route path="/data_deletion_guide" element={<DataDeletion/>} />
          <Route path="/cs" element={<CS/>} />
          
        </Routes>
      </Router>
    </AppProvider>
  );
}

export default App;
